import { Chess } from 'chess.js';
const CENTER_SQUARES = ['d4', 'e4', 'd5', 'e5'];
export function checkCenterControl(fenBefore, fenAfter) {
    const chessBefore = new Chess(fenBefore);
    const chessAfter = new Chess(fenAfter);
    const side = chessBefore.turn();
    const countControl = (chess, s) => {
        let count = 0;
        CENTER_SQUARES.forEach(sq => {
            const piece = chess.get(sq);
            if (piece && piece.color === s)
                count += 2; // Occupying is strong
            // Checking attackers/defenders is harder with chess.js alone without a full engine
            // but we can check if it's attacked by our pieces
            // This is a simplified version
        });
        return count;
    };
    const before = countControl(chessBefore, side);
    const after = countControl(chessAfter, side);
    if (after > before && after >= 2) {
        return {
            id: 'center_control',
            severity: 'low',
            data: { value: after - before }
        };
    }
    return null;
}
